import gql from 'graphql-tag';

export const LOGIN = gql`
  mutation(
    $orgId: Int!
    $email: String
    $password: String
    $captchaToken: String
    $locale: String

    $externalId: String
    $phoneNumber: String,
  ) {
    login(
      input: {
        email: $email
        password: $password
        otpMethod: INTERNAL_OTP
        userType: PATIENT
        orgId: $orgId
        captchaToken: $captchaToken
        locale: $locale
        externalIdType: POLICY
        externalId: $externalId
        phoneNumber: $phoneNumber
      }
    ) {
      token
      refreshToken
      # tosRequired
      # changePasswordRequired
      isLastLoginFailedAttempt
      phoneNumber
    }
  }
`;

export const SECONDARY_LOGIN = gql`
  mutation(
    $orgId: Int!
    $email: String
    $locale: String
    $captchaToken: String
    $externalId: String
    $title: String
    $firstName: String
    $lastName: String
    $middleName: String
    $dateOfBirth: String
    $phoneNumber: String
    $gender: Gender
    $address: String
  ) {
    login(
      input: {
        orgId: $orgId
        userType: PATIENT
        email: $email
        otpMethod: INTERNAL_OTP
        locale: $locale
        captchaToken: $captchaToken
        externalId: $externalId
        title: $title
        firstName: $firstName
        lastName: $lastName
        middleName: $middleName
        dateOfBirth: $dateOfBirth
        phoneNumber: $phoneNumber
        gender: $gender
        address: $address
      }
    ) {
      token
      refreshToken
      # tosRequired
      # changePasswordRequired
      isLastLoginFailedAttempt
      phoneNumber
    }
  }
`;
